import Tracker from "../Tracker.js";
import AmplitudeTracker from "./AmplitudeTracker.js";
/**
 * Creates and installs the Connected History Router
 */
export default {
  id: 'molten.AmplitudeTracking',
  sort: -100,
  // Install as soon as possible

  init: molten => {
    const options = molten.getConfig('amplitude') || {};
    if (options.apiKey) {
      const tracker = new AmplitudeTracker(options);
      tracker.init();
      Tracker.addClient(tracker);
    }
  }
};